// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import LocationFieldController from "./location_field_controller"
application.register("location-field", LocationFieldController)

import NumberFieldController from "./number_field_controller"
application.register("number-field", NumberFieldController)

import PeopleFieldController from "./people_field_controller"
application.register("people-field", PeopleFieldController)

import TripFormController from "./trip_form_controller"
application.register("trip-form", TripFormController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)
